import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const CarInsurance = ({ t, market }) => {
    return (_jsxs("div", { className: "card-insurance", children: [_jsx("h5", { className: "card-insurance__title", id: "insurance_title", children: t("medical_tag") }), _jsx("img", { className: "card-insurance__image", alt: t("medical_tag"), src: market != "CA" ? t("url_car_insurance") : t("url_car_insurance_canada") })] }));
};
export default CarInsurance;
